import { useTellescopeMutation } from "@tellescope/tanstack-query";

/**
 * Hook for all Stripe subscription mutations.
 *
 * Supported operations (passed via the `type` field in the mutation request):
 * - `subscription-cancel`: Cancel at end of billing period
 * - `subscription-undo-cancel`: Undo a scheduled cancellation
 * - `subscription-pause`: Pause billing
 * - `subscription-resume`: Resume a paused subscription
 * - `subscription-update-payment-method`: Update default payment method
 *
 * Cache invalidation is handled automatically by the tanstack-query side effect configs.
 */
export function useStripeSubscriptionMutation() {
  return useTellescopeMutation({
    model: "integrations",
    method: "proxy_write",
    autoCacheUpdateStrategy: "invalidate",
  });
}
